<template>
  <div class="container">
    <transition name="fade-transform" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
  export default {};
</script>
<style lang="scss" scoped>
  .container {
    height: 100%;
    //height: calc(100vh - 60px);
    position: relative;
    width: 100%;
    .contents {
      height: 100%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      overscroll-behavior: contain;
    }
  }
</style>
